import api from '../api';

export const getAdminSwimmers = async (search = '') => {
    console.log('Sending request to /admin/swimmers'); // Отладочное сообщение
    try {
        const response = await api.get('/admin/swimmers', {
            params: { search }
        });
        console.log('API response:', response); // Важно!
        return response;
    } catch (error) {
        console.error('API error:', error); // Важно!
        throw error;
    }
};

export const updateSwimmerPayment = (id, data) => {
    return api.put(`/admin/swimmers/${id}`, data);
};
